const CONVERSION_KEY = 'builder_converted';

const hasAlreadyConverted = (): boolean => {
  try {
    return sessionStorage.getItem(CONVERSION_KEY) === '1';
  } catch {
    return false;
  }
};

const markConverted = (): void => {
  try {
    sessionStorage.setItem(CONVERSION_KEY, '1');
  } catch {
    // silently ignore sessionStorage errors (e.g. private browsing)
  }
};

export const trackBuilderConversion = (amount?: number) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (hasAlreadyConverted()) {
    return;
  }

  import('@builder.io/react')
    .then(({ builder }) => {
      try {
        if (typeof amount === 'number') {
          builder.trackConversion(amount);
        } else {
          builder.trackConversion();
        }
        markConverted();
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.error('[Builder] trackConversion error', error);
        }
      }
    })
    .catch(() => {
      // silently ignore import errors
    });
};
